<c-container [fluid]="true" class="py-3">
  <c-row class="mb-3">
    <c-col>
      <h2 class="mb-1">{{ 'viacarte_admin.title' | translate }}</h2>
      <p class="text-medium-emphasis mb-0">{{ 'viacarte_admin.subtitle' | translate }}</p>
    </c-col>
  </c-row>

  <!-- Entity-Wallet (Guthaben = Quelle der Account-Aufladungen) -->
  <c-row class="mb-3">
    <c-col>
      <c-card>
        <c-card-body class="d-flex flex-wrap align-items-center gap-3 py-3">
          <div class="me-auto">
            <div class="text-medium-emphasis small">{{ 'viacarte_admin.entity_wallet' | translate }}</div>
            <div *ngIf="entityBalanceError() as eb" class="text-danger small">{{ eb }}</div>
            <div *ngIf="!entityBalanceError() && entityPockets().length === 0" class="text-medium-emphasis">—</div>
          </div>
          <div *ngFor="let p of entityPockets()" class="text-end">
            <div class="text-medium-emphasis small">{{ p.currencyName || p.currencyId || '' }}</div>
            <div class="fs-4 fw-semibold">{{ formatAmount(p.balance, p.currencyName) }}</div>
          </div>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>

  <!-- Status-Kacheln -->
  <c-row class="mb-3 g-2">
    <c-col [md]="3" [sm]="6" *ngFor="let s of statuses">
      <c-card class="h-100">
        <c-card-body class="py-2 px-3">
          <div class="text-medium-emphasis small text-truncate">{{ 'viacarte_status.' + s | translate }}</div>
          <div class="fs-5 fw-semibold">{{ statName(s) }}</div>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>

  <c-card>
    <c-card-header class="d-flex flex-wrap gap-2 align-items-center">
      <strong class="me-auto">{{ 'viacarte_admin.list_title' | translate }} ({{ totalCount() }})</strong>

      <select cSelect class="w-auto"
              [ngModel]="statusFilter()"
              (ngModelChange)="statusFilter.set($event); onStatusFilterChange()">
        <option value="">{{ 'viacarte_admin.all_statuses' | translate }}</option>
        <option *ngFor="let s of statuses" [value]="s">{{ 'viacarte_status.' + s | translate }}</option>
      </select>

      <input cFormControl class="w-auto"
             [placeholder]="'viacarte_admin.search_placeholder' | translate"
             [ngModel]="searchFilter()"
             (ngModelChange)="searchFilter.set($event)" />

      <button cButton color="secondary" variant="outline" size="sm" (click)="load()">
        {{ 'viacarte_admin.refresh' | translate }}
      </button>
    </c-card-header>

    <c-card-body>
      <div *ngIf="loading()" class="text-center py-5">
        <c-spinner></c-spinner>
      </div>

      <div *ngIf="error()" class="alert alert-danger">{{ error() }}</div>

      <div *ngIf="!loading() && !error()">
        <table cTable [hover]="true" [responsive]="true" class="align-middle">
          <thead>
            <tr>
              <th>ID</th>
              <th>{{ 'viacarte_admin.name' | translate }}</th>
              <th>{{ 'viacarte_admin.email' | translate }}</th>
              <th>{{ 'viacarte_admin.brand' | translate }}</th>
              <th>{{ 'viacarte_admin.status' | translate }}</th>
              <th>{{ 'viacarte_admin.customer_id' | translate }}</th>
              <th>{{ 'viacarte_admin.cards' | translate }}</th>
              <th>{{ 'viacarte_admin.registered_at' | translate }}</th>
              <th class="text-end">{{ 'viacarte_admin.actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="users().length === 0">
              <td colspan="9" class="text-center text-medium-emphasis py-4">
                {{ 'viacarte_admin.empty' | translate }}
              </td>
            </tr>
            <tr *ngFor="let u of users()" style="cursor: pointer;" (click)="openDetail(u)">
              <td>
                {{ u.id }}
                <c-badge *ngIf="u.deleted" color="dark" class="ms-1">del</c-badge>
              </td>
              <td>{{ u.first_name }} {{ u.last_name }}</td>
              <td class="text-truncate" style="max-width: 200px;">{{ u.email }}</td>
              <td><c-badge color="info">{{ u.brand }}</c-badge></td>
              <td>
                <c-badge [color]="u.status_badge">{{ u.status || '—' }}</c-badge>
              </td>
              <td><code class="small">{{ shortId(u.customer_id) }}</code></td>
              <td>
                <c-badge *ngIf="u.physical_card_id" color="success" class="me-1" title="physical">P</c-badge>
                <c-badge *ngIf="u.virtual_card_id" color="primary" title="virtual">V</c-badge>
                <span *ngIf="!u.physical_card_id && !u.virtual_card_id" class="text-medium-emphasis">—</span>
              </td>
              <td class="small text-nowrap">{{ formatDate(u.registered_at) }}</td>
              <td class="text-end">
                <button cButton color="primary" variant="outline" size="sm" (click)="openDetail(u); $event.stopPropagation()">
                  {{ 'viacarte_admin.details' | translate }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <c-pagination *ngIf="totalPages() > 1" class="mt-3 mb-0" aria-label="Page navigation">
          <li cPageItem [disabled]="page() === 1">
            <a cPageLink (click)="goToPage(page() - 1)" style="cursor: pointer;">‹</a>
          </li>
          <li cPageItem *ngFor="let p of visiblePages()" [active]="p === page()">
            <a cPageLink (click)="goToPage(p)" style="cursor: pointer;">{{ p }}</a>
          </li>
          <li cPageItem [disabled]="page() === totalPages()">
            <a cPageLink (click)="goToPage(page() + 1)" style="cursor: pointer;">›</a>
          </li>
        </c-pagination>
      </div>
    </c-card-body>
  </c-card>
</c-container>
